import React, { useEffect, useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import Cookies from "js-cookie";
import moment from "moment";
import ServerLimitExceeded from "./components/ServerLimitExceeded";
import "./App.css";

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = Cookies.get("theme");
    return saved ? saved === "dark" : true;
  });

  useEffect(() => {
    Cookies.set("theme", darkMode ? "dark" : "light", { expires: 365 });
    document.documentElement.setAttribute(
      "data-theme",
      darkMode ? "dark" : "light",
    );
  }, [darkMode]);

  const toggleTheme = () => setDarkMode(!darkMode);

  return (
    <div className="app-container">
      {/* Animated Background */}
      <div className="ambient-light light-1"></div>
      <div className="ambient-light light-2"></div>
      <div className="ambient-light light-3"></div>

      {/* Navbar */}
      <nav className="app-navbar">
        <div className="nav-brand">
          <i className="bi bi-shield-lock-fill brand-icon"></i>
          <span className="brand-text">SecureFlow</span>
        </div>
        <div className="nav-actions">
          <button
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label="Toggle theme"
          >
            <i
              className={`bi ${darkMode ? "bi-sun-fill" : "bi-moon-stars-fill"}`}
            ></i>
          </button>
        </div>
      </nav>

      {/* Main Content */}
      <main className="app-main">
        <ServerLimitExceeded />
      </main>

      {/* Footer */}
      <footer className="app-footer">
        <p>© {moment().format("YYYY")} SecureFlow. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
